export function getEnumFromString<T extends object>(
  type: T,
  str?: string | null
): T[keyof T] | undefined {
  if (!!str && str in type) {
    const casted = str as keyof T;
    return type[casted];
  } else return undefined;
}
